/** 标签栏收起图标。 */
export function CloseSlideIcon() {
    return (
        <svg className="tabs-control-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path
                d="M17 4.32983C17.4142 4.32983 17.75 4.66562 17.75 5.07983C17.75 5.49405 17.4142 5.82983 17 5.82983H3C2.58579 5.82983 2.25 5.49405 2.25 5.07983C2.25 4.66562 2.58579 4.32983 3 4.32983H17Z"
                fill="currentColor"
            />
            <path
                d="M9.51562 9.18117C9.92979 9.18122 10.2656 9.51699 10.2656 9.93117C10.2656 10.3453 9.92979 10.6811 9.51562 10.6812H3C2.58579 10.6812 2.25 10.3454 2.25 9.93117C2.25 9.51695 2.58579 9.18117 3 9.18117H9.51562Z"
                fill="currentColor"
            />
            <path
                d="M9.51562 14.0107C9.92979 14.0108 10.2656 14.3466 10.2656 14.7607C10.2656 15.1749 9.92979 15.5107 9.51562 15.5107H3C2.58579 15.5107 2.25 15.175 2.25 14.7607C2.25 14.3465 2.58579 14.0107 3 14.0107H9.51562Z"
                fill="currentColor"
            />
            <path d="M17 10.9202L14 12.9202L17 14.9202V10.9202Z" fill="currentColor" />
            <path
                d="M17.3535 10.259C17.1097 10.1287 16.8141 10.1428 16.584 10.2961L13.584 12.2961C13.3753 12.4352 13.25 12.6694 13.25 12.9202C13.25 13.1709 13.3753 13.4051 13.584 13.5442L16.584 15.5442C16.8141 15.6976 17.1097 15.7117 17.3535 15.5813C17.5974 15.4508 17.75 15.1968 17.75 14.9202V10.9202C17.75 10.6436 17.5974 10.3896 17.3535 10.259ZM16.25 13.5188L15.3525 12.9202L16.25 12.3215V13.5188Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default CloseSlideIcon;
